import { render, staticRenderFns } from "./SubscriptionPurchaseLayout2.vue?vue&type=template&id=6df6a66a&"
import script from "./SubscriptionPurchaseLayout2.vue?vue&type=script&lang=js&"
export * from "./SubscriptionPurchaseLayout2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports